import isEi from 'features/Onboarding/common/isEi';

import { VerificationStatus } from '../../Verification/lib/steps/types';

const getBeneficiariesModuleStatus = ({
  hasRegisteredAllBeneficiaries,
  isMainApplicant,
  legalForm,
}: {
  hasRegisteredAllBeneficiaries: boolean;
  legalForm: string;
  isMainApplicant: boolean;
}): VerificationStatus => {
  if (isEi(legalForm) || !isMainApplicant) {
    return VerificationStatus.Irrelevant;
  }

  return hasRegisteredAllBeneficiaries
    ? VerificationStatus.Completed
    : VerificationStatus.ToDo;
};

export default getBeneficiariesModuleStatus;
